import { VUE_APP_WX_SIGNATURE_URL } from "./request"
import request from "./request"

export function getWeChatInfo() {
    return request({
        url: VUE_APP_WX_SIGNATURE_URL,
        method: "get",
        params: { shareUrl: window.location.href.split('#')[0] }
    }).then(res => res.data.data)
}
